export const messageResendZajavls = 'Для того чтобы изменения были учтены в ранее отправленных заявлениях, их следует переотправить';
export const messageResendZajavlsEn = 'For the changes to be reflected in previously submitted applications, they should be resubmitted.';
